import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { CustomerUserRoutesApplication } from '../../constants';

function setupCustomerUser(): void {
  applicationModuleRegistry.register({
    closeable: true,
    entry: 'customer-user',
    id: 'customer-user',
    name: 'user.list-title',
    route: CustomerUserRoutesApplication.CUSTOMER_USER_LIST,
  });
}

export {
  setupCustomerUser,
};
